export default __webpack_public_path__ + "static/media/taimur-rashid.4429b983.jpg";